module.exports = __webpack_public_path__ + "static/media/rakuten_logo.5352b781.png";